import { Button, Card, CardErrorBoundaryWithSpinfinity } from 'components';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import styles from './MainFindings.module.css';
import MainFindingsCards from './MainFindingsCards';
import MainFindingsEvaluations from './MainFindingsEvaluations';

type MainFindingsProps = {
  className?: string;
};

export function MainFindings({ className }: MainFindingsProps) {
  const { currentKit } = useCurrentKitAndTinyAccount();

  return (
    <CardErrorBoundaryWithSpinfinity cardName='MainFindings'>
      <Card title='Main findings' className={className}>
        <MainFindingsEvaluations />
        <MainFindingsCards currentKitId={currentKit?.id} />
        <Button
          color='purple'
          className={styles.button}
          width='full'
          href={`/results/${currentKit?.id}/insights/all-insights?evaluations=red%2Corange%2Cgreen%2Cgrey`}
        >
          See all metrics
        </Button>
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
}
